export enum EHelpCurationStatus {
  Pending = 'PENDING',
  Promoted = 'PROMOTED',
  Rejected = 'REJECTED',
}
